import { Breadcrumb } from 'features/page-model/types';

export function getBreadcrumbsPath(breadcrumbs: Breadcrumb[]) {
  return breadcrumbs.reduce((data: string, breadcrumb) => {
    if (!breadcrumb.label) {
      return data;
    }

    if (!data) {
      return breadcrumb.label;
    }

    return data + ` / ${breadcrumb.label}`;
  }, '');
}
